import React, { useMemo } from "react";
import { renderFormattedDate } from "../../../../utils/formHelper";
import PropTypes from "prop-types";

export const formatCurrency = (value, getNaIfEmpty = true) => {
  if (value === null || value === undefined || value === "" || isNaN(Number(value))) {
    return getNaIfEmpty ? "N/A" : "$0.00";
  }
  const numberValue = typeof value === "number" ? value : 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(numberValue);
};

export function CurrencyCell({ value }) {
  return <div className="center">{formatCurrency(value, true)}</div>;
}

export function currencyColumnDef({ align = "center", ...rest }) {
  return {
    headerAlign: align,
    align: align,
    valueGetter: params => parseFloat(params.value?.toString().replace(/[^0-9.-]+/g, "")) || 0,
    sortComparator: (v1, v2) => v1 - v2,
    renderCell: params => <CurrencyCell value={params.value} />,
    ...rest
  };
}

export function DateCell({ value }) {
  const formattedDateValue = useMemo(() => renderFormattedDate(value), [value]);
  return <div>{formattedDateValue || "N/A"}</div>;
}

export function dateColumnDef({ align = "left", ...rest }) {
  return {
    headerAlign: align,
    align: align,
    renderCell: params => <DateCell value={params.value} />,
    ...rest
  };
}

export function PercentageCell({ value }) {
  const formatedValue = useMemo(() => {
    const numberValue = value ?? "N/A";
    if (isNaN(numberValue)) return numberValue;
    return `${Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 })}%`;
  }, [value]);
  return <div className="center">{formatedValue}</div>;
}

export function percentageColumnDef({ align = "center", ...rest }) {
  return {
    headerAlign: align,
    align: align,
    renderCell: params => <PercentageCell value={params.value} />,
    ...rest
  };
}

export function FormatHoursMinutesCell({ value }) {
  const formattedValue = useMemo(() => {
    if (isNaN(value)) return "N/A";
    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);
    return `${hours} hours ${minutes} minutes`;
  }, [value]);
  return <div className="center">{formattedValue}</div>;
}

export function hoursMinutesColumnDef({ align = "center", ...rest }) {
  return {
    headerAlign: align,
    align: align,
    renderCell: params => <FormatHoursMinutesCell value={params.value} />,
    ...rest
  };
}

CurrencyCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DateCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PercentageCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FormatHoursMinutesCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
